import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as React from "react";
import { Provider } from "react-redux";
import "./assets/materialicons.css";
import "./assets/fontsLato.css";
import "./assets/swiper/swiper.css"; // core Swiper
import "./assets/swiper/modules/navigation.css"; // Navigation module
import "./assets/swiper/modules/pagination.css"; // Pagination module
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import esLocale from "date-fns/locale/es";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { SnackbarProvider } from "notistack";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";

import AppRoutes from "./routes";
import configureStore from "./redux/store";

const theme = createTheme({
  palette: {
    primary: {
      main: "#006699",
    },
    secondary: {
      main: "#7092be",
    },
    background: {
      default: "#efefef",
    },
    color: {
      default: "#fafafa",
    },
  },
  components: {
    MuiAutocomplete: {
      defaultProps: {
        size: "small",
        fullWidth: true,
        margin: "dense",
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        fullWidth: true,
        margin: "dense",
        onFocus: (e) =>
          typeof e.target.select === "function" && e.target.select(),
      },
    },
    MuiDatePicker: {
      defaultProps: {
        textfield: { size: "small", fullWidth: true, margin: "dense" },
      },
    },
  },
});
const store = configureStore();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={esLocale}
        >
          <CssBaseline />
          <AppRoutes />
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>,
);

serviceWorker.unregister();
